<template>
  <div>
    <MainView v-if="canStartApp"> </MainView>
  </div>
</template>

<script>
import MainView from "./views/MainView";
import Utils from "./helpers/utils";
import { defineCustomElement } from "vue";
export default {
  components: { MainView },
  //props: ["dataUrl"],
  name: "App",
  data() {
    return {
      dataUrl: "",
      zipUrl: "",
      onCusomChatTestPage: null,
      widgetHost: null,
      canStartApp: false,
    };
  },
  created() {
    Utils.log.debug("App created");
    //set window.Vidyo_Identifier_SendInviteMessage with default parameter;
    window.Vidyo_Identifier_SendInviteMessage = "VidyoSendInviteMessage";

    //determine if on test page or an a tenant site
    this.onCusomChatTestPage = document.getElementById("customchat-test-page");
    //in case user decide to get zip file from inner folder   
    this.setWidgetHostFromEmbeddedElement();
    this.setUrlToGetZip();
    // this.checkVersion();
  },
  methods: {
    //set desired data from the "data-url" attribute
    setWidgetHostFromEmbeddedElement() {
      //let customChatDataFileUrl = document.getElementsByTagName("custom-chat")[0].attributes[0].value;
      let customChatDataFileUrl =
        document.getElementById("app").attributes.getNamedItem('data-url').value;
      this.dataUrl = customChatDataFileUrl;
      this.widgetHost = customChatDataFileUrl.split("/")[2];
      //social connector helper api app name
      this.schapi = customChatDataFileUrl.split("/")[3];
      this.$store.commit("setParsedWidgetHost", this.widgetHost);
      this.$store.commit("setParsedSCHAPI", this.schapi);

      //get IISAppName from HTML
      if (document.getElementById("app-script")) {
        let IISAppScriptArr = document
          .getElementById("app-script")
          .src.split("/");
        let IISAppName = IISAppScriptArr[IISAppScriptArr.length - 3];
        this.$store.commit("setParsedIISAppName", IISAppName);
      }
      let route = document.getElementById("app").attributes.getNamedItem('route');
      if (route && route.value !== '')
        this.$store.commit("setInitialRoute", route.value);
      let callID = document.getElementById("app").attributes.getNamedItem('callID');
      if (callID && callID.value !== '')
        this.$store.commit("setPassedCallID", callID.value);
        
    },
    setUrlToGetZip() {
      /********************************************************** For development purpose only! ***************************************************/
      /********************************************************************************************************************************************/

      /* Case 1: If tenant iniside on CusomChatTestPage, and he supply params
        folder - if he want to get zip from inner folder (test case 1 on deployment guide)
        widgetid - if he want to get zip from real server api (test case 2 on deployment guide)*/
      let paramsObj = Utils.getUrlVars();
      let folderName = paramsObj["folder"];
      let widgetId = paramsObj["widgetid"];            
      let browserURLHost = window.location.host;

      if (this.onCusomChatTestPage) {
        Utils.log.debug("take zip from folder");
        if (folderName && browserURLHost.includes("localhost")) {
          this.zipUrl = `${location.protocol}//localhost/PS.CustomChat/${folderName}/data.zip`;
          this.canStartApp = true;
        } else if (folderName && !browserURLHost.includes("localhost")) {
          Utils.log.error(
            "Can access zip from local folder, only from localhost"
          );
          return;
        } else if (widgetId) {
          /*Case 2:  if ...?widgetId=XXXXXXXXXXX   at URL
        can */
          Utils.log.debug("take zip from configportal, take widgetId from url");
          this.canStartApp = true;
          this.$store.state.widgetId = widgetId;
          this.zipUrl = `${location.protocol}//${this.widgetHost}/${this.$store.state.helperApiAppName}/api/customchat/getWidgetConfiguration?WidgetId=${widgetId}`;
        } else {
          Utils.log.debug(
            "take zip from configportal, take widgetId from index.html"
          );
          this.canStartApp = true;
          this.zipUrl = this.dataUrl;
        }

        // Allow route override
        let route = paramsObj['route'];
        if (route && route !== '')
          this.$store.commit("setInitialRoute", route);
        let callID = paramsObj['callID'];
        if (callID && callID !== '')
          this.$store.commit("setPassedCallID", callID);           

        /*******************************************************************************************************************************************/
        /*******************************************************************************************************************************************/

        /*Case 3: Get zip url from embedded element (both for 'new-window'/'embededed' modes)*/
      } else {
        Utils.log.info("Not development mode - Take zip from ConfigPortal.");
        this.canStartApp = true;
        const urlParams = new URL(this.dataUrl).searchParams;
        this.$store.state.widgetId = urlParams.get('WidgetId');
        this.zipUrl = this.dataUrl;
      }
      this.$store.commit("setDataFileUrl", this.zipUrl);
      this.extractAnsSetOptParameters();
    },
    extractAnsSetOptParameters() {
      let optParamsObj = Utils.getCustomUrlVars(this.zipUrl);
      this.$store.commit("setOptionalPatametersFromAPI", optParamsObj);
    },
  },
};
</script>
<style>
.v-alert__close {
  margin-inline-end: -13px !important;
  align-self: flex-start !important;
  -webkit-margin-start: 90px !important;
  margin-inline-start: 0px !important;
}

div.v-field.v-field--single-line {
  border-radius: 100px !important;
}

/* centralize confirm windows (Vue3 change) */
:not(.v-tooltip):not(.v-menu) > .v-overlay__content{
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
/* override user css (Vue3 change) */
.chat-box {
    z-index: 0 !important;
}
</style>
